module.exports = __webpack_public_path__ + "img/cloud-2.132e9f41.svg";